import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserState } from './store/user/user.model';
import { logout } from './store/user/user.actions';
import { map, switchMap } from 'rxjs/operators';

const decryptJWT = (jwt: string) => {
  const base64Url = jwt.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

export const authGuard: ResolveFn<boolean> = (): Observable<boolean> | boolean => {
  const store = inject(Store<{ user: UserState }>);
  const router = inject(Router);

  return timer(0, 60000).pipe(  // Check every minute
    switchMap(() => store.select('user')),
    map((userState) => {
      try {
        if (userState.userInfo && userState.isLoggedIn) {
          const jwt = userState.userInfo.accessToken;
          const decodedToken = decryptJWT(jwt);
          const expTime = decodedToken.exp * 1000;
          const loginTime = decodedToken.auth_time * 1000;
          const currentTime = Date.now();

          if (currentTime > expTime || (currentTime - loginTime) > 3600000) {  // Logout every hour
            console.log('Logout due to one hour limit');
            return handleLogout(store, router);
          }
          return true;
        
        } else {
          return handleLogout(store, router);
        }
      } catch (error) {
        return handleLogout(store, router);
      }
    })
  );
};

function handleLogout(store: Store<{ user: UserState }>, router: Router) {
  store.dispatch(logout());
  router.navigate(['/login']);
  return false;
}